// Footer.jsx

import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="lux-footer">

      <div className="lux-footer-overlay" />

      <div className="lux-footer-inner">

        <div className="lux-footer-grid">

          {/* BRAND */}
          <div className="lux-footer-brand">
            <h2>SMARTVIZX</h2>
            <p>
              Designing bespoke environments where creativity and functionality meets technology.
              We craft spatial experiences that elevate how people connect,
              interact, and feel.
            </p>
          </div>

          {/* PRODUCTS */}
          <div className="lux-footer-card">
            <h3>Products</h3>
            <ul>
              <li>
                <a
                  href="https://trezi.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Trezi Platform
                </a>
              </li>
            </ul>
          </div>

          {/* COMPANY */}
          <div className="lux-footer-card">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">Team</Link></li>
              <li><Link to="/career">Careers</Link></li>
              <li><Link to="/press">Press</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
            </ul>
          </div>

          {/* SOCIAL */}
          <div className="lux-footer-card">
            <h3>Connect</h3>

            <div className="lux-socials">
              {[
                {
                  href: "https://www.linkedin.com/company/smartvizs-pvt-ltd-/",
                  icon: "linkedin",
                },
                {
                  href: "https://www.facebook.com/smartvizx/",
                  icon: "facebook",
                },
                {
                  href: "https://twitter.com/ByTrezi",
                  icon: "twitter",
                },
                {
                  href: "https://www.instagram.com/smartvizx/",
                  icon: "instagram",
                },
                {
                  href: "https://www.youtube.com/channel/UCnAGo5MdsIyM9UIDn7_ouOg",
                  icon: "youtube",
                },
              ].map(({ href, icon }) => (
                <a
                  key={icon}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`/img/svg/${icon}.svg`}
                    alt={icon}
                  />
                </a>
              ))}
            </div>
          </div>

        </div>

        <div className="lux-footer-bottom">
          <p> 2026 SMARTVIZX — Crafted with precision & vision</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;